import { embedParentOriginMatchesMessage } from 'services/embed_parent_origin'

/** Parent → iframe embed prefill (aligns with calendly.page_height naming). */
const EMBED_PREFILL_MESSAGE_EVENT = 'calendly.prefill'

let lastPrefillPayload = null
const subscribers = new Set()

const normalizeEmbedPrefillPayload = (raw) => {
  if (!raw || typeof raw !== 'object') return null

  const first_name = raw.first_name ?? raw.firstName ?? ''
  const last_name = raw.last_name ?? raw.lastName ?? ''
  let full_name = raw.full_name ?? raw.fullName ?? raw.name ?? ''
  if (!full_name && (first_name || last_name)) {
    full_name = [first_name, last_name].filter(Boolean).join(' ')
  }
  const email = raw.email ?? ''
  const customAnswers = {}
  if (raw.customAnswers && typeof raw.customAnswers === 'object') {
    Object.assign(customAnswers, raw.customAnswers)
  }
  Object.keys(raw).forEach((key) => {
    const m = key.match(/^a(\d+)$/)
    if (m && raw[key] != null && raw[key] !== '') {
      customAnswers[key] = raw[key]
    }
  })
  let guests = []
  if (Array.isArray(raw.guests)) {
    guests = raw.guests.filter(Boolean)
  } else if (typeof raw.guests === 'string' && raw.guests.trim()) {
    guests = raw.guests.split(',').map((s) => s.trim()).filter(Boolean)
  }

  if (!first_name && !last_name && !full_name && !email && guests.length === 0
    && Object.keys(customAnswers).length === 0) {
    return null
  }

  return {
    first_name,
    last_name,
    full_name,
    email,
    customAnswers,
    guests,
  }
}

const notifySubscriber = (callback, payload) => {
  try {
    callback(payload)
  } catch {
    /* noop */
  }
}

const dispatchPrefillToSubscribers = (payload) => {
  lastPrefillPayload = payload
  subscribers.forEach((cb) => {
    notifySubscriber(cb, payload)
  })
}

export const handleEmbedPrefillMessage = (event) => {
  if (!event?.data || event.data.event !== EMBED_PREFILL_MESSAGE_EVENT) return
  if (!embedParentOriginMatchesMessage(window.location.search, event.origin)) return

  const normalized = normalizeEmbedPrefillPayload(event.data.payload)
  if (!normalized) return
  dispatchPrefillToSubscribers(normalized)
}

export const subscribeEmbedPrefill = (callback) => {
  subscribers.add(callback)
  if (lastPrefillPayload) notifySubscriber(callback, lastPrefillPayload)
  return () => subscribers.delete(callback)
}
